import styled from "styled-components";

export const StyledCompetitorCell = styled.div<{ $isReverse?: boolean }>`
  display: flex;
  align-items: center;
  gap: 5px;

  ${({ $isReverse }) =>
    $isReverse &&
    `
    justify-content: end;
    flex-direction: row-reverse;
  `}
`;
StyledCompetitorCell.displayName = "StyledCompetitorCell";
